import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { FaChild, FaCalendarAlt, FaUtensils, FaHandsHelping, FaQuoteLeft, FaGlobeAmericas, FaHeart } from 'react-icons/fa';
import '../css/funds.css';

export default function Funds() {
    const location = useLocation();
    const isAboutPage = location.pathname === '/about';

    const stats = [
        {
            icon: <FaChild />,
            count: "30+",
            label: "Children Housed",
            desc: "Full-time residential sanctuary, medical care, and clothing.",
            glowColor: "rgba(253, 190, 51, 0.2)"
        },
        {
            icon: <FaCalendarAlt />,
            count: "15+",
            label: "Years of Care",
            desc: "Serving homeless and disadvantaged youth since May 2009.",
            glowColor: "rgba(59, 130, 246, 0.2)"
        },
        {
            icon: <FaUtensils />,
            count: "50,000+",
            label: "Meals Served",
            desc: "Wholesome, home-cooked nutritious food 3 times a day.",
            glowColor: "rgba(34, 197, 94, 0.2)"
        },
        {
            icon: <FaHandsHelping />,
            count: "100%",
            label: "Direct Impact",
            desc: "Every rupee directly supports children's welfare & supplies.",
            glowColor: "rgba(168, 85, 247, 0.2)"
        }
    ];

    return (
        <>
            {/* High-End Bento Impact Counters */}
            <section className="obsidian-impact-section">
                <div className="ambient-radial-glow"></div>
                <Container className="position-relative">
                    <div className="text-center mb-5">
                        <div className="impact-pill-badge">
                            <FaHeart className="text-danger me-2" /> Real Lives, Real Change
                        </div>
                        <h2 className="impact-title mt-2">
                            Measurable Impact Built on <span className="text-gold-glow">Unconditional Love</span>
                        </h2>
                        <p className="impact-subtitle mx-auto">
                            Numbers tell our story, but the smiling faces of our children are our true achievements.
                        </p>
                    </div>

                    <Row className="g-4">
                        {stats.map((stat, idx) => (
                            <Col key={idx} xs={12} sm={6} lg={3}>
                                <div className="obsidian-stat-capsule">
                                    <div className="stat-capsule-glow" style={{ background: stat.glowColor }}></div>
                                    <div className="stat-icon-halo">
                                        {stat.icon}
                                    </div>
                                    <h3 className="stat-metric-number">{stat.count}</h3>
                                    <h5 className="stat-metric-label">{stat.label}</h5>
                                    <p className="stat-metric-desc">{stat.desc}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Testimonials / International Visitors */}
            {isAboutPage && (
                <section className="global-fellowship-section py-5">
                    <Container>
                        <div className="fellowship-glass-container p-4 p-md-5">
                            <Row className="align-items-center g-5">
                                <Col lg={4}>
                                    <span className="badge-tag" style={{ background: 'rgba(59, 130, 246, 0.15)', color: '#2563eb' }}>
                                        <FaGlobeAmericas className="me-2" /> Global Partnerships
                                    </span>
                                    <h3 className="fw-bold mt-2 text-dark">International Visitors & Volunteers</h3>
                                    <p className="text-muted small mt-2">
                                        Supporters travel across the world to spend quality time, teach English, organize activities, and uplift our children.
                                    </p>
                                </Col>
                                <Col lg={8}>
                                    <div className="fellowship-quote-card position-relative">
                                        <FaQuoteLeft className="quote-mark" />
                                        <p className="fellowship-quote-body">
                                            "Our friends Marcus and Abigail from England have supported our work since 2013. They regularly visit, organize games, and show immense love to the boys. Their consistent presence and generous support have been a blessing beyond words to Loving Arms Orphanage."
                                        </p>
                                        <div className="d-flex align-items-center gap-3 mt-4">
                                            <div className="avatar-chip">MA</div>
                                            <div>
                                                <h6 className="fw-bold mb-0 text-dark">Marcus & Abigail</h6>
                                                <small className="text-muted">Long-time Supporters from England, UK</small>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </section>
            )}
        </>
    );
}